
import ProgressSpinner from './ProgressSpinner.vue';
import { defineComponent } from 'vue';

export default defineComponent({
	name: 'FullScreenLoader',
	components: {
		ProgressSpinner,
	},
});
